import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"

const Footer = ({ buttonLabel, onSuccessUrl, nextStep, dark }) => (
  <Grid style={{ paddingBottom: "1em" }}>
    <Grid.Row
      columns={2}
      className={`SummaryFooter__Row${dark ? "-dark" : ""} `}
    >
      <Grid.Column width={8} verticalAlign="middle">
        {nextStep ? (
          <p>
            <i>Next: {nextStep}</i>
          </p>
        ) : null}
      </Grid.Column>
      <Grid.Column textAlign="right" width={8}>
        <Link to={onSuccessUrl}>
          <Button primary>{buttonLabel}</Button>
        </Link>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

Footer.propTypes = {
  buttonLabel: PropTypes.string,
  onSuccessUrl: PropTypes.string,
  nextStep: PropTypes.string
}

Footer.defaultProps = {
  buttonLabel: "Continue",
  onSuccessUrl: "/"
}

export default Footer
